import * as React from 'react'
import styled from 'styled-components'
import { ComponentWrapper, OnboardingComponentProps } from '.'
import { StackChildren } from '@doordash/design-language'
import { OnboardingComponent } from 'src/components/organisms/workflow-template/types'
import ListItem from '../list-item'

export const FlexContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`
/**
 * Represents the workflow platform component for the progression list item component.
 *
 *
 * @param {OnboardingComponent[]} components - An array of internal components that would
 *    are generally placed inside the current active progression step.
 *
 * @param {TemplateResponseData} templateResponeData - The data structure for the buttons
 *    to modify and send back to the backend when they are triggered
 *
 * @param {Function} onChange - A required parameter for the component wrapper
 *
 * @param {Function} onSubmitStep - Handles component submissions and triggers updateOnboarding calls
 *
 * @param {boolean} is_active - Represents whether the current step will display as the currently
 *      active step.
 *
 * @param {string} title - Represents the title of the list item
 *
 * @param {boolean} is_complete - Represents the completion status of the progression list item, list items
 *    prior to the active item should show as completed
 *
 * @param {boolean} isSeparatorShown - Represents whether the list item will show a separator or not
 *
 * @param {number} step - Represents the step number that this list item is
 *
 * @returns {JSX.Element} Progression List Item Component
 */
export const ProgressionListItemComponent: React.FC<OnboardingComponentProps> = ({
  components,
  templateResponseData,
  onChange,
  onSubmitStep,
  is_active,
  title,
  is_complete = false,
  step,
  badge_text,
  show_progress_line = true,
}) => {
  const mainComponents = components
    ? components.filter(component => component.type !== 'BUTTON_COMPONENT')
    : null

  const buttons = components
    ? components.filter(component => component.type === 'BUTTON_COMPONENT')
    : null

  return (
    <ListItem
      step={step}
      title={() => title}
      isActive={is_active}
      isComplete={is_complete}
      showSeparator={true}
      badgeText={badge_text}
      trackClick={() => null}
      showProgressLine={show_progress_line}
    >
      <StackChildren size={StackChildren.Sizes.Small}>
        {mainComponents &&
          mainComponents.map(
            (component: OnboardingComponent, index: number) => (
              <div key={index}>{ComponentWrapper(component)}</div>
            )
          )}
        <FlexContainer>
          {buttons &&
            buttons.map((component: OnboardingComponent, index: number) => (
              <div key={index}>
                {ComponentWrapper(
                  component,
                  onChange,
                  templateResponseData,
                  onSubmitStep
                )}
              </div>
            ))}
        </FlexContainer>
      </StackChildren>
    </ListItem>
  )
}
